/* eslint-disable no-param-reassign */
import Fetch, { V1, V2, serializeQueryString } from 'Util/fetcher';

const ON_REQUEST_STOCK_DETAIL_NEWS = 'ON_REQUEST_STOCK_DETAIL_NEWS';
const ON_REQUEST_STOCK_DETAIL_NEWS_FAILURE = 'ON_REQUEST_STOCK_DETAIL_NEWS_FAILURE';
const ON_REQUEST_STOCK_DETAIL_NEWS_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_NEWS_SUCCESS';
function onRequestStockDetailNews(resetData) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_NEWS,
    meta: { resetData },
  };
}
function onRequestStockDetailNewsSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_NEWS_SUCCESS,
    payload,
  };
}
function onRequestStockDetailNewsFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_NEWS_FAILURE,
    payload,
  };
}

export const onDoRequestStockDetailNews =
  (code, payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestStockDetailNews(resetData));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}news/feed/stock/${code}/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestStockDetailNewsSuccess(resp.json));
        } else {
          dispatch(onRequestStockDetailNewsFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockDetailNewsFailure(error.message));
      });
  };

const ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED = 'ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED';
const ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_FAILURE';
const ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_SUCCESS';
function onRequestStockDetailKeyStatisticRanked() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED,
  };
}
function onRequestStockDetailKeyStatisticRankedSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_SUCCESS,
    payload,
  };
}
function onRequestStockDetailKeyStatisticRankedFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailKeyStatisticRanked = (code) => (dispatch) => {
  dispatch(onRequestStockDetailKeyStatisticRanked());
  Fetch.get(`${V1}stock/detail/${code}/ranked/key_statistics/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailKeyStatisticRankedSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailKeyStatisticRankedFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailKeyStatisticRankedFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR = 'ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR';
const ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_FAILURE';
const ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_SUCCESS';
function onRequestStockDetailFinancialYear() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR,
  };
}
function onRequestStockDetailFinancialYearSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_SUCCESS,
    payload,
  };
}
function onRequestStockDetailFinancialYearFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailFinancialYear = (code) => (dispatch) => {
  dispatch(onRequestStockDetailFinancialYear());
  Fetch.get(`${V1}stock/detail/${code}/financial/year/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailFinancialYearSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailFinancialYearFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailFinancialYearFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL =
  'ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL';
const ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_FAILURE';
const ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_SUCCESS';
function onRequestStockDetailKeyStatisticHistorical() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL,
  };
}
function onRequestStockDetailKeyStatisticHistoricalSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_SUCCESS,
    payload,
  };
}
function onRequestStockDetailKeyStatisticHistoricalFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailKeyStatisticHistorical = (code, payload) => (dispatch) => {
  dispatch(onRequestStockDetailKeyStatisticHistorical());
  const qs = serializeQueryString(payload);
  Fetch.get(`${V1}stock/detail/${code}/key_statistics/historical/${qs}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailKeyStatisticHistoricalSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailKeyStatisticHistoricalFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailKeyStatisticHistoricalFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR = 'ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR';
const ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_FAILURE';
const ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_SUCCESS';
function onRequestStockDetailTechIndicator() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR,
  };
}
function onRequestStockDetailTechIndicatorSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_SUCCESS,
    payload,
  };
}
function onRequestStockDetailTechIndicatorFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailTechIndicator = (code, type) => (dispatch) => {
  dispatch(onRequestStockDetailTechIndicator());
  Fetch.get(`${V1}stock/detail/${code}/tech_indicator/?type=${type}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailTechIndicatorSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailTechIndicatorFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailTechIndicatorFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_CATEGORIES = 'ON_REQUEST_STOCK_DETAIL_CATEGORIES';
const ON_REQUEST_STOCK_DETAIL_CATEGORIES_FAILURE = 'ON_REQUEST_STOCK_DETAIL_CATEGORIES_FAILURE';
const ON_REQUEST_STOCK_DETAIL_CATEGORIES_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_CATEGORIES_SUCCESS';
function onRequestStockDetailCategories() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_CATEGORIES,
  };
}
function onRequestStockDetailCategoriesSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_CATEGORIES_SUCCESS,
    payload,
  };
}
function onRequestStockDetailCategoriesFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_CATEGORIES_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailCategories = (code) => (dispatch) => {
  dispatch(onRequestStockDetailCategories());
  Fetch.get(`${V1}stock/detail/${code}/categories/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailCategoriesSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailCategoriesFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailCategoriesFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_CORP_ACTION = 'ON_REQUEST_STOCK_DETAIL_CORP_ACTION';
const ON_REQUEST_STOCK_DETAIL_CORP_ACTION_FAILURE = 'ON_REQUEST_STOCK_DETAIL_CORP_ACTION_FAILURE';
const ON_REQUEST_STOCK_DETAIL_CORP_ACTION_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_CORP_ACTION_SUCCESS';
function onRequestStockDetailCorpAction(resetData) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_CORP_ACTION,
    meta: { resetData },
  };
}
function onRequestStockDetailCorpActionSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_CORP_ACTION_SUCCESS,
    payload,
  };
}
function onRequestStockDetailCorpActionFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_CORP_ACTION_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailCorpAction =
  (code, type, payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestStockDetailCorpAction(resetData));
    const qs = serializeQueryString({
      act_type: type,
      ...payload,
    });
    Fetch.get(`${V1}stock/detail/${code}/corporate-action/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestStockDetailCorpActionSuccess(resp.json));
        } else {
          dispatch(onRequestStockDetailCorpActionFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockDetailCorpActionFailure(error.message));
      });
  };

const ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT = 'ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT';
const ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_FAILURE = 'ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_FAILURE';
const ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_SUCCESS';
function onRequestStockDetailAnnouncement(resetData) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT,
    meta: { resetData },
  };
}
function onRequestStockDetailAnnouncementSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_SUCCESS,
    payload,
  };
}
function onRequestStockDetailAnnouncementFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailAnnouncement =
  (code, payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestStockDetailAnnouncement(resetData));
    const qs = serializeQueryString({
      ...payload,
    });
    Fetch.get(`${V1}stock/detail/${code}/announcement/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestStockDetailAnnouncementSuccess(resp.json));
        } else {
          dispatch(onRequestStockDetailAnnouncementFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockDetailAnnouncementFailure(error.message));
      });
  };

const ON_REQUEST_STOCK_DETAIL_FINANCIAL = 'ON_REQUEST_STOCK_DETAIL_FINANCIAL';
const ON_REQUEST_STOCK_DETAIL_FINANCIAL_FAILURE = 'ON_REQUEST_STOCK_DETAIL_FINANCIAL_FAILURE';
const ON_REQUEST_STOCK_DETAIL_FINANCIAL_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_FINANCIAL_SUCCESS';
function onRequestStockDetailFinancial() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FINANCIAL,
  };
}
function onRequestStockDetailFinancialSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FINANCIAL_SUCCESS,
    payload,
  };
}
function onRequestStockDetailFinancialFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FINANCIAL_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailFinancial = (code, payload) => (dispatch) => {
  dispatch(onRequestStockDetailFinancial());
  const qs = serializeQueryString(payload);
  Fetch.get(`${V1}stock/detail/${code}/financial/${qs}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailFinancialSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailFinancialFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailFinancialFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES =
  'ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES';
const ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_FAILURE';
const ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_SUCCESS';
function onRequestStockDetailForeignTradingValues() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES,
  };
}
function onRequestStockDetailForeignTradingValuesSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_SUCCESS,
    payload,
  };
}
function onRequestStockDetailForeignTradingValuesFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailForeignTradingValues = (code) => (dispatch) => {
  dispatch(onRequestStockDetailForeignTradingValues());
  Fetch.get(`${V1}stock/detail/${code}/price/foreign-activity/value/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailForeignTradingValuesSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailForeignTradingValuesFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailForeignTradingValuesFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES = 'ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES';
const ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_FAILURE';
const ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_SUCCESS';
function onRequestStockDetailForeignActivities() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES,
  };
}
function onRequestStockDetailForeignActivitiesSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_SUCCESS,
    payload,
  };
}
function onRequestStockDetailForeignActivitiesFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailForeignActivities = (code, range) => (dispatch) => {
  dispatch(onRequestStockDetailForeignActivities());
  Fetch.get(`${V1}stock/detail/${code}/price/foreign-activity/?range=${range}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailForeignActivitiesSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailForeignActivitiesFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailForeignActivitiesFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE = 'ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE';
const ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_FAILURE =
  'ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_FAILURE';
const ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_SUCCESS =
  'ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_SUCCESS';
function onRequestStockDetailPriceCompare() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE,
  };
}
function onRequestStockDetailPriceCompareSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_SUCCESS,
    payload,
  };
}
function onRequestStockDetailPriceCompareFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailPriceCompare = (code) => (dispatch) => {
  dispatch(onRequestStockDetailPriceCompare());
  Fetch.get(`${V1}stock/detail/${code}/price/compare/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailPriceCompareSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailPriceCompareFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailPriceCompareFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_PRICE_RANGE = 'ON_REQUEST_STOCK_DETAIL_PRICE_RANGE';
const ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_FAILURE = 'ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_FAILURE';
const ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_SUCCESS';
function onRequestStockDetailPriceRange() {
  return {
    type: ON_REQUEST_STOCK_DETAIL_PRICE_RANGE,
  };
}
function onRequestStockDetailPriceRangeSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_SUCCESS,
    payload,
  };
}
function onRequestStockDetailPriceRangeFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_FAILURE,
    payload,
  };
}
export const onDoRequestStockDetailPriceRange = (code, period) => (dispatch) => {
  dispatch(onRequestStockDetailPriceRange());
  Fetch.get(`${V1}stock/detail/${code}/price/range/?range=${period}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockDetailPriceRangeSuccess(resp.json));
      } else {
        dispatch(onRequestStockDetailPriceRangeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockDetailPriceRangeFailure(error.message));
    });
};

const ON_REQUEST_STOCK_DETAIL_FORUM = 'ON_REQUEST_STOCK_DETAIL_FORUM';
const ON_REQUEST_STOCK_DETAIL_FORUM_SUCCESS = 'ON_REQUEST_STOCK_DETAIL_FORUM_SUCCESS';
const ON_REQUEST_STOCK_DETAIL_FORUM_FAILURE = 'ON_REQUEST_STOCK_DETAIL_FORUM_FAILURE';

function onRequestStockDetailForum(resetData) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FORUM,
    meta: { resetData },
  };
}
function onRequestStockDetailForumSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FORUM_SUCCESS,
    payload,
  };
}
function onRequestStockDetailForumFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_DETAIL_FORUM_FAILURE,
    payload,
  };
}

export const onDoRequestStockDetailForum =
  (code, payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestStockDetailForum(resetData));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V2}communities/post/analysis/${code}/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestStockDetailForumSuccess(resp.json));
        } else {
          dispatch(onRequestStockDetailForumFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockDetailForumFailure(error.message));
      });
  };

const INITIAL_STATE = {
  newsLoading: false,
  newsData: null,
  newsError: null,

  keyStatisticRankedLoading: false,
  keyStatisticRankedData: null,
  keyStatisticRankedError: null,

  financialYearLoading: false,
  financialYearData: null,
  financialYearError: null,

  keyStatisticHistoricalLoading: false,
  keyStatisticHistoricalData: null,
  keyStatisticHistoricalError: null,

  techIndicatorLoading: false,
  techIndicatorData: null,
  techIndicatorError: null,

  financialLoading: false,
  financialData: null,
  financialError: null,

  foreignTradingValuesLoading: false,
  foreignTradingValuesData: null,
  foreignTradingValuesError: null,

  foreignActivitiesLoading: false,
  foreignActivitiesData: null,
  foreignActivitiesError: null,

  priceCompareLoading: false,
  priceCompareData: null,
  priceCompareError: null,

  priceRangeLoading: false,
  priceRangeData: null,
  priceRangeError: null,

  categoryLoading: false,
  categoryData: null,
  categoryError: null,

  corpActionLoading: false,
  corpActionData: null,
  corpActionError: null,

  announcementLoading: false,
  announcementData: null,
  announcementError: null,

  forumLoading: false,
  forumData: null,
  forumError: null,
};

const stockDetailComponent = (state = INITIAL_STATE, { type, payload, meta } = {}) => {
  switch (type) {
    case ON_REQUEST_STOCK_DETAIL_NEWS:
      if (meta.resetData) {
        return {
          ...state,
          newsLoading: true,
          newsData: null,
          newsError: null,
        };
      }
      return {
        ...state,
        newsLoading: true,
        newsError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_NEWS_SUCCESS:
      if (state.newsData) {
        const oldResults = [...state.newsData.results];
        state.newsData = {
          ...payload,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.newsData = payload;
      }
      return {
        ...state,
        newsLoading: false,
        newsError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_NEWS_FAILURE:
      return {
        ...state,
        newsLoading: false,
        newsError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED:
      return {
        ...state,
        keyStatisticRankedLoading: true,
        keyStatisticRankedError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_SUCCESS:
      return {
        ...state,
        keyStatisticRankedLoading: false,
        keyStatisticRankedData: payload,
        keyStatisticRankedError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_RANKED_FAILURE:
      return {
        ...state,
        keyStatisticRankedLoading: false,
        keyStatisticRankedError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR:
      return {
        ...state,
        financialYearLoading: true,
        financialYearError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_SUCCESS:
      return {
        ...state,
        financialYearLoading: false,
        financialYearData: payload,
        financialYearError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FINANCIAL_YEAR_FAILURE:
      return {
        ...state,
        financialYearLoading: false,
        financialYearError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL:
      return {
        ...state,
        keyStatisticHistoricalLoading: true,
        keyStatisticHistoricalError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_SUCCESS:
      return {
        ...state,
        keyStatisticHistoricalLoading: false,
        keyStatisticHistoricalData: payload,
        keyStatisticHistoricalError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_KEY_STATISTIC_HISTORICAL_FAILURE:
      return {
        ...state,
        keyStatisticHistoricalLoading: false,
        keyStatisticHistoricalError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR:
      return {
        ...state,
        techIndicatorLoading: true,
        techIndicatorError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_SUCCESS:
      return {
        ...state,
        techIndicatorLoading: false,
        techIndicatorData: payload,
        techIndicatorError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_TECH_INDICATOR_FAILURE:
      return {
        ...state,
        techIndicatorLoading: false,
        techIndicatorError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_FINANCIAL:
      return {
        ...state,
        financialLoading: true,
        financialError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FINANCIAL_SUCCESS:
      return {
        ...state,
        financialLoading: false,
        financialData: payload,
        financialError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FINANCIAL_FAILURE:
      return {
        ...state,
        financialLoading: false,
        financialError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES:
      return {
        ...state,
        foreignTradingValuesLoading: true,
        foreignTradingValuesError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_SUCCESS:
      return {
        ...state,
        foreignTradingValuesLoading: false,
        foreignTradingValuesData: payload,
        foreignTradingValuesError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FOREIGN_TRADING_VALUES_FAILURE:
      return {
        ...state,
        foreignTradingValuesLoading: false,
        foreignTradingValuesError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES:
      return {
        ...state,
        foreignActivitiesLoading: true,
        foreignActivitiesError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_SUCCESS:
      return {
        ...state,
        foreignActivitiesLoading: false,
        foreignActivitiesData: payload,
        foreignActivitiesError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FOREIGN_ACTIVITIES_FAILURE:
      return {
        ...state,
        foreignActivitiesLoading: false,
        foreignActivitiesError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE:
      return {
        ...state,
        priceCompareLoading: true,
        priceCompareError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_SUCCESS:
      return {
        ...state,
        priceCompareLoading: false,
        priceCompareData: payload,
        priceCompareError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_PRICE_COMPARE_FAILURE:
      return {
        ...state,
        priceCompareLoading: false,
        priceCompareError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_PRICE_RANGE:
      return {
        ...state,
        priceRangeLoading: true,
        priceRangeError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_SUCCESS:
      return {
        ...state,
        priceRangeLoading: false,
        priceRangeData: payload,
        priceRangeError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_PRICE_RANGE_FAILURE:
      return {
        ...state,
        priceRangeLoading: false,
        priceRangeError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_CATEGORIES:
      return {
        ...state,
        categoryLoading: true,
        categoryError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoryLoading: false,
        categoryData: payload,
        categoryError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_CATEGORIES_FAILURE:
      return {
        ...state,
        categoryLoading: false,
        categoryError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_CORP_ACTION:
      if (meta.resetData) {
        return {
          ...state,
          corpActionLoading: true,
          corpActionData: null,
          corpActionError: null,
        };
      }
      return {
        ...state,
        corpActionLoading: true,
        corpActionError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_CORP_ACTION_SUCCESS:
      if (state.corpActionData) {
        const oldResults = [...state.corpActionData.results];
        state.corpActionData = {
          ...payload,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.corpActionData = payload;
      }
      return {
        ...state,
        corpActionLoading: false,
        corpActionError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_CORP_ACTION_FAILURE:
      return {
        ...state,
        corpActionLoading: false,
        corpActionError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT:
      if (meta.resetData) {
        return {
          ...state,
          announcementLoading: true,
          announcementData: null,
          announcementError: null,
        };
      }
      return {
        ...state,
        announcementLoading: true,
        announcementError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_SUCCESS:
      if (state.announcementData) {
        const oldResults = [...state.announcementData.results];
        state.announcementData = {
          ...payload,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.announcementData = payload;
      }
      return {
        ...state,
        announcementLoading: false,
        announcementError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        announcementLoading: false,
        announcementError: payload,
      };

    case ON_REQUEST_STOCK_DETAIL_FORUM:
      if (meta.resetData) {
        return {
          ...state,
          forumLoading: true,
          forumData: null,
          forumError: null,
        };
      }
      return {
        ...state,
        forumLoading: true,
        forumError: null,
      };

    case ON_REQUEST_STOCK_DETAIL_FORUM_SUCCESS:
      if (state.forumData) {
        const oldResults = [...state.forumData.results];
        state.forumData = {
          ...payload,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.forumData = payload;
      }
      return {
        ...state,
        forumLoading: false,
        forumError: null,
      };
    case ON_REQUEST_STOCK_DETAIL_FORUM_FAILURE:
      return {
        ...state,
        forumLoading: false,
        forumError: payload,
      };

    default:
      return state;
  }
};

export default stockDetailComponent;
